// extracted by mini-css-extract-plugin
export var container = "_is-0";
export var content = "_is-3";
export var customerTitle = "_is-4";
export var empty = "_is-5";
export var gray = "_is-6";
export var header = "_is-7";
export var info = "_is-8";
export var loading = "_is-2";
export var loadingCard = "_is-9";
export var oneLine = "_is-a";
export var personName = "_is-e";
export var pillContainer = "_is-b";
export var selected = "_is-1";
export var text = "_is-c";
export var twoLines = "_is-d";
export var unread = "_is-f";
export var unreadIndicator = "_is-g";